export default "__VITE_ASSET__BL541fMA__"